import { useContext } from 'react';

import { OverviewContext } from '../context';
import { OverviewContextProps } from '../context/types';

export function useAnalyticsOverview(): OverviewContextProps {
    return useContext(OverviewContext);
}
